module.exports = __webpack_public_path__ + "media/images/stop-sign-0f777980490a50c9d747d0621188235d.svg";